export default "__VITE_ASSET__67e044fa__"